import { SettingConst } from '@faire/web-api--source/types';

/**
 * Experiment setting to enable displaying Product Level Reviews (aka PLR) to retailers on the PDP.
 * Retry after rollback due to bucketing issue.
 */
export const ENABLE_PRODUCT_REVIEW_RETAILER_DISPLAY_XP_V2_250627 =
  'ENABLE_PRODUCT_REVIEW_RETAILER_DISPLAY_XP_V2_250627' as SettingConst<
    'ENABLE_PRODUCT_REVIEW_RETAILER_DISPLAY_XP_V2_250627',
    boolean,
    'RETAILER' | 'VISITOR_WEB' | 'HOTJAR_RETAILER' | 'RETAILER_IOS'
  >;
